import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import az from "./locales/az.json";
import en from "./locales/en.json";
import ru from "./locales/ru.json";

export const SUPPORTED_LANGUAGES = [
  { code: "az", nativeName: "Azərbaycanca", flag: "🇦🇿" },
  { code: "en", nativeName: "English", flag: "🇬🇧" },
  { code: "ru", nativeName: "Русский", flag: "🇷🇺" },
];

export const LANGUAGE_STORAGE_KEY = "gredus.language";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      az: { translation: az },
      en: { translation: en },
      ru: { translation: ru },
    },
    fallbackLng: "az",
    supportedLngs: ["az", "en", "ru"],
    nonExplicitSupportedLngs: false,
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

export default i18n;
